(function () {
  var STANDARD_TABLE_SIZES = [9, 12, 14, 16, 18, 20, 22];
  var CUSTOM_TABLE_SIZES = Array.from({ length: 14 }, function (_, index) {
    return index + 9;
  });
  var MIN_END_CLEARANCE = 2.5;
  var MAX_END_CLEARANCE = 3;
  var SMALL_CABINET_WIDTH_INCHES = 25.5;
  var LARGE_CABINET_WIDTH_INCHES = 31.5;
  var ONE_WALKWAY_FEET = 2;
  var COMFORTABLE_WALKWAY_FEET = 3;

  var SHOP_LINKS = {
    9: "https://mccluretables.com/collections/9-foot-shuffleboard-tables-for-sale-mcclure-tables",
    12: "https://mccluretables.com/collections/12-foot-shuffleboard-tables",
    14: "https://mccluretables.com/collections/14-foot-shuffleboard-tables",
    16: "https://mccluretables.com/collections/16-foot-shuffleboard-tables",
    18: "https://mccluretables.com/collections/18-foot-shuffleboard-tables",
    20: "https://mccluretables.com/collections/20-foot-shuffleboard-tables",
    22: "https://mccluretables.com/collections/22-foot-suffleboard-tables"
  };

  var PLANNER_BASE_URL = "/pages/space-planner";

  function requiredLength(tableSize, clearancePerEnd) {
    return tableSize + clearancePerEnd * 2;
  }

  function cabinetWidthInFeet(tableSize) {
    var inches = tableSize >= 16 ? LARGE_CABINET_WIDTH_INCHES : SMALL_CABINET_WIDTH_INCHES;
    return inches / 12;
  }

  function getWidthClassification(roomWidth, cabinetWidthFeet) {
    if (roomWidth < cabinetWidthFeet) return "Too narrow";
    if (roomWidth < cabinetWidthFeet + ONE_WALKWAY_FEET) return "Fits tightly against wall";
    if (roomWidth < cabinetWidthFeet + COMFORTABLE_WALKWAY_FEET) return "Fits with one walkway";
    return "Fits comfortably";
  }

  function getFitStatus(roomLength, roomWidth, tableSize) {
    var minimumLength = requiredLength(tableSize, MIN_END_CLEARANCE);
    var comfortableLength = requiredLength(tableSize, MAX_END_CLEARANCE);
    var cabinetWidthFeet = cabinetWidthInFeet(tableSize);
    var widthClassification = getWidthClassification(roomWidth, cabinetWidthFeet);
    var widthFits = widthClassification !== "Too narrow";
    var fitsMinimumLength = roomLength >= minimumLength;
    var fitsComfortableLength = roomLength >= comfortableLength;
    var fitsMinimum = fitsMinimumLength && widthFits;
    var fitsComfortably = fitsComfortableLength && widthFits;

    return {
      tableSize: tableSize,
      minimumLength: minimumLength,
      comfortableLength: comfortableLength,
      cabinetWidthFeet: cabinetWidthFeet,
      widthClassification: widthClassification,
      widthFits: widthFits,
      fitsMinimumLength: fitsMinimumLength,
      fitsComfortableLength: fitsComfortableLength,
      fitsMinimum: fitsMinimum,
      fitsComfortably: fitsComfortably
    };
  }

  function findBestStandardSize(results) {
    var standardFits = results.filter(function (item) {
      return item.fitsMinimum;
    });
    return standardFits.length ? standardFits[standardFits.length - 1] : null;
  }

  function initCalculator(wrapper) {
    if (!wrapper || wrapper.dataset.sbInitialized === "true") return;
    wrapper.dataset.sbInitialized = "true";

    var form = wrapper.querySelector("[data-sb-form]");
    var roomLengthInput = wrapper.querySelector("[data-sb-room-length]");
    var roomWidthInput = wrapper.querySelector("[data-sb-room-width]");
    var bestSizeElement = wrapper.querySelector("[data-sb-best-size]");
    var resultNoteElement = wrapper.querySelector("[data-sb-result-note]");
    var recommendationBadgesElement = wrapper.querySelector("[data-sb-badges]");
    var resultsGridElement = wrapper.querySelector("[data-sb-results-grid]");
    var recommendedListElement = wrapper.querySelector("[data-sb-recommended-list]");
    var customSizePanelElement = wrapper.querySelector("[data-sb-custom-panel]");
    var customSizeNoteElement = wrapper.querySelector("[data-sb-custom-note]");
    var noFitSummaryElement = wrapper.querySelector("[data-sb-no-fit-summary]");
    var warningElement = wrapper.querySelector("[data-sb-warning]");
    var shopLinkElement = document.getElementById("shop-size-link");
    var plannerLinkElement = document.getElementById("planner-size-link");
    var helpCtaElement = wrapper.querySelector(".sb-room-calc__help-cta");

    var noFitPanelElement = noFitSummaryElement
      ? noFitSummaryElement.closest(".sb-room-calc__panel")
      : null;

    if (!form || !roomLengthInput || !roomWidthInput) return;

    function hideActionCtas() {
      if (shopLinkElement) {
        shopLinkElement.style.display = "none";
      }
      if (plannerLinkElement) {
        plannerLinkElement.style.display = "none";
      }
      if (helpCtaElement) {
        helpCtaElement.style.display = "none";
      }
    }

    function showHelpCta() {
      if (helpCtaElement) {
        helpCtaElement.style.display = "flex";
      }
    }

    function showShopAndPlanner(size) {
      if (shopLinkElement && SHOP_LINKS[size]) {
        shopLinkElement.href = SHOP_LINKS[size];
        shopLinkElement.textContent = "Shop " + size + "ft Shuffleboard Tables";
        shopLinkElement.style.display = "inline-block";
      }

      if (plannerLinkElement) {
    plannerLinkElement.href = PLANNER_BASE_URL + "?size=" + size + "#footprint-visuals";
        plannerLinkElement.textContent = "Plan This " + size + "ft Layout";
        plannerLinkElement.style.display = "inline-block";
      }

      showHelpCta();
    }

    function renderRecommendation(item) {
      recommendedListElement.innerHTML = "";

      if (!item) {
        var emptyItem = document.createElement("li");
        emptyItem.className = "sb-room-calc__size-item";
        emptyItem.textContent = "No standard size recommendation yet.";
        recommendedListElement.appendChild(emptyItem);
        return;
      }

      var listItem = document.createElement("li");
      listItem.className = "sb-room-calc__size-item fit";

      var main = document.createElement("div");
      main.className = "sb-room-calc__size-main";

      var label = document.createElement("span");
      label.className = "sb-room-calc__size-title";
      label.textContent = item.tableSize + "ft table";

      var subtitle = document.createElement("span");
      subtitle.className = "sb-room-calc__size-subtitle";
      subtitle.textContent = item.fitsComfortably
        ? "Best standard-size choice with a roomier 3ft at each end"
        : "Best standard-size choice for normal home play with 2.5ft at each end";

      var meta = document.createElement("div");
      meta.className = "sb-room-calc__size-meta";
      meta.textContent = item.widthClassification + " width • needs " + item.minimumLength.toFixed(1) + "ft minimum room length";

      main.appendChild(label);
      main.appendChild(subtitle);
      listItem.appendChild(main);
      listItem.appendChild(meta);
      recommendedListElement.appendChild(listItem);
    }

    function renderBadges(roomLength, roomWidth) {
      recommendationBadgesElement.innerHTML = "";
      [
        "Room length: " + roomLength.toFixed(1) + "ft",
        "Room width: " + roomWidth.toFixed(1) + "ft",
        "End clearance target: 2.5ft to 3ft each end"
      ].forEach(function (text) {
        var badge = document.createElement("div");
        badge.className = "sb-room-calc__badge";
        badge.textContent = text;
        recommendationBadgesElement.appendChild(badge);
      });
    }

    function renderNoFitSummary(nonFittingTables) {
      if (!nonFittingTables.length) {
        noFitSummaryElement.textContent = "No larger standard sizes are ruled out by the current room dimensions.";
        return;
      }

      var widthBlocked = nonFittingTables.every(function (item) {
        return !item.widthFits;
      });

      if (widthBlocked) {
        noFitSummaryElement.textContent = "The room is narrower than the cabinet width needed for the standard sizes checked here.";
        return;
      }

      var first = nonFittingTables[0].tableSize;
      var last = nonFittingTables[nonFittingTables.length - 1].tableSize;
      noFitSummaryElement.textContent = first === last
        ? first + "ft is too large for this room."
        : first + "ft to " + last + "ft are too large for this room.";
    }

    function renderCustomSizeNote(note) {
      var shouldShow = Boolean(note);

      customSizePanelElement.hidden = !shouldShow;

      if (noFitPanelElement) {
        noFitPanelElement.hidden = shouldShow;
      }

      resultsGridElement.classList.remove("two-column", "three-column");
      resultsGridElement.classList.add("two-column");

      customSizeNoteElement.textContent = shouldShow ? note : "";
    }

    function getCustomSizeNote(bestStandardFit, customFits, results) {
      if (!bestStandardFit || bestStandardFit.tableSize !== 9) return "";

      var twelve = results.find(function (item) {
        return item.tableSize === 12;
      });

      if (twelve && twelve.fitsMinimum) return "";

      var ten = customFits.find(function (item) {
        return item.tableSize === 10 && item.fitsMinimum;
      });

      var eleven = customFits.find(function (item) {
        return item.tableSize === 11 && item.fitsMinimum;
      });

      if (!ten && !eleven) return "";

      if (ten && eleven) {
        return "A custom 10ft or 11ft table may be worth considering here if you want something larger than a standard 9ft table but the standard 12ft size is too long. Custom off-size tables usually cost a little more.";
      }

      if (eleven) {
        return "A custom 11ft table may be worth considering here if you want something larger than a standard 9ft table but the standard 12ft size is too long. Custom off-size tables usually cost a little more.";
      }

      if (ten) {
        return "A custom 10ft table may be worth considering here if you want something larger than a standard 9ft table but the standard 12ft size is too long. Custom off-size tables usually cost a little more.";
      }

      return "";
    }

    function updateResults(roomLength, roomWidth) {
      var standardResults = STANDARD_TABLE_SIZES.map(function (tableSize) {
        return getFitStatus(roomLength, roomWidth, tableSize);
      });

      var customResults = CUSTOM_TABLE_SIZES
        .filter(function (tableSize) {
          return STANDARD_TABLE_SIZES.indexOf(tableSize) === -1;
        })
        .map(function (tableSize) {
          return getFitStatus(roomLength, roomWidth, tableSize);
        });

      var bestStandardFit = findBestStandardSize(standardResults);
      var roomyStandardFits = standardResults.filter(function (item) {
        return item.fitsComfortably;
      });
      var standardNonFits = standardResults.filter(function (item) {
        return !item.fitsMinimum;
      });
      var customFits = customResults.filter(function (item) {
        return item.fitsMinimum;
      });
      var customNote = getCustomSizeNote(bestStandardFit, customFits, standardResults);

      renderBadges(roomLength, roomWidth);
      renderRecommendation(bestStandardFit);
      renderCustomSizeNote(customNote);
      renderNoFitSummary(standardNonFits);

      if (bestStandardFit) {
        bestSizeElement.textContent = "Recommended size: " + bestStandardFit.tableSize + "ft";

        resultNoteElement.textContent = bestStandardFit.fitsComfortably
          ? "This is the largest standard size that fits the room with a roomier setup, so it is the clearest buying recommendation."
          : "This is the largest standard size that fits well for normal home play, which makes it the clearest buying recommendation.";

        warningElement.hidden = roomyStandardFits.length > 0;
        warningElement.textContent = roomyStandardFits.length > 0
          ? ""
          : "This recommendation uses the common 2.5ft-per-end planning standard, which is often sufficient for normal home use.";

        showShopAndPlanner(bestStandardFit.tableSize);
        return;
      }

      hideActionCtas();

      if (standardResults.some(function (item) { return item.widthFits; })) {
        bestSizeElement.textContent = "No standard table size fits this room.";
        resultNoteElement.textContent = "The room is short for the smallest standard size once realistic end clearance is included.";
        renderCustomSizeNote(customNote);
        warningElement.hidden = false;
        warningElement.textContent = "No standard size is a strong fit here, so you may need to consider a smaller custom table or a different room.";
        showHelpCta();
        return;
      }

      bestSizeElement.textContent = "Room is too narrow for these table sizes.";
      resultNoteElement.textContent = "The room width is below the cabinet width needed for the standard sizes checked here.";
      renderCustomSizeNote("");
      warningElement.hidden = false;
      warningElement.textContent = "Warning: room width is too narrow for the cabinet itself. Check doorway-style clear widths and confirm actual table cabinet dimensions before ordering.";
      showHelpCta();
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      var roomLength = Number(roomLengthInput.value);
      var roomWidth = Number(roomWidthInput.value);

      if (roomLength <= 0 || roomWidth <= 0) {
        bestSizeElement.textContent = "Enter valid room dimensions.";
        resultNoteElement.textContent = "Both room length and room width need to be greater than zero.";
        recommendationBadgesElement.innerHTML = "";
        recommendedListElement.innerHTML = "";
        customSizeNoteElement.innerHTML = "";
        noFitSummaryElement.innerHTML = "";
        customSizePanelElement.hidden = true;

        if (noFitPanelElement) {
          noFitPanelElement.hidden = false;
        }

        resultsGridElement.classList.remove("three-column");
        resultsGridElement.classList.add("two-column");
        warningElement.hidden = false;
        warningElement.textContent = "Please enter positive numbers for both room dimensions.";
        hideActionCtas();
        return;
      }

      updateResults(roomLength, roomWidth);

      var resultsSection = wrapper.querySelector(".sb-room-calc__results");
      if (resultsSection) {
        resultsSection.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });

    hideActionCtas();
  }

  function initAllRoomCalculators() {
    document.querySelectorAll("[data-sb-room-calc]").forEach(initCalculator);
  }

  initAllRoomCalculators();
  document.addEventListener("shopify:section:load", initAllRoomCalculators);
})();